module.exports = __webpack_public_path__ + "static/media/css.da015616.png";